import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net';
import { useLocation, useNavigate } from "react-router";
import baseConfig from "../../core/config/Config";
import {OrderService} from "./Service";
import toast from "react-hot-toast";



const ManageOrders = () => {
    const service = new OrderService();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        try {
            $('#table').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token')
        $('#table').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data, type, row) {
                        return `<b>#${data}</b>`
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 0
                },
                {

                    "render": function (data, type, row) {
                        if (data === 'Pending') {
                            return `<p class="badge bg-primary p-2">${data}</p>`;
                        } else if (data === 'Failed') {
                            return `<p class="badge bg-danger p-2">${data}</p>`;
                        } else {
                            return `<p class="badge bg-success p-2">${data}</p>`;
                        }
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 4
                },
                // Show dropdown to change status
                {
                    "render": function (data, type, row) {
                        return `<select class="form-control select2">
                        <option value="Pending">Pending</option>
                        <option value="Failed">Failed</option>
                        <option value="Order Received">Order Received</option>
                        <option value="Order Completed">Order Completed</option>
                        </select>`;
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).change(async (e) => {
                            console.log(e.target.value);
                            const res = await service.update(rowData[5], {
                                orderStatus: e.target.value
                            });
                            if (res) {
                                toast.success('Order status updated successfully');
                                getData();
                            }
                        });
                    },
                    "targets": 5
                },
                {

                    "render": function (data, type, row) {
                        return `<button class="btn btn-primary">Details</button>`;
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).click(e => {
                            // console.log('CLICKED');
                            navigate(`${location.pathname}/details/${cellData}`);
                        })
                    },
                    "targets": 7
                },
            ],
            ajax: {
                url: `${baseConfig.apiBaseUrl}/order/list`,
                type: "POST",
                contentType: "application/json",
                headers: {
                    "Authorization": token,
                },
                data: function (d) {
                    return JSON.stringify(d);
                },
            }
        });
    }

    return (
        <div>

            <div className="card mt-3">
                <div className="card-header p-3">
                    <h5 className="card-title">Manage Orders</h5>
                </div>
                <div className="card-body">
                    <div className='table-responsive w-100'>
                        <table
                            id="table"
                            className='table datatable w-100'
                        >
                            <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>User</th>
                                <th>Total Items</th>
                                <th>Total Amount</th>
                                <th>Status</th>
                                <th>Change Status</th>
                                <th>Purchase Date</th>
                                <th>Details</th>
                            </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default ManageOrders;
